import { type DeliveryNote, type Execution } from '~/types/deliveryNote';

import { type FormDeliveryNoteFormFields } from '~/modules/ai-parser-review/components/FormDeliveryNote';
import { REPARSING_DATA_PATHS_MAP } from '~/modules/asset-reparsing/constants';

import { getNestedProperty } from '@vestigas/utils';
import { datetime4server, formatAsUTCDate } from '~/utils';

import { executionTimestampFields } from '../mapReparsingAssetsQueryData';

import { updateNumericField } from './utils';

export const updateExecutionData = (
  draft: DeliveryNote,
  formData: FormDeliveryNoteFormFields,
) => {
  const executionDraft = getNestedProperty<Execution>(
    draft,
    REPARSING_DATA_PATHS_MAP.execution,
  );
  const executionFormData = getNestedProperty<Execution>(
    formData,
    REPARSING_DATA_PATHS_MAP.execution,
  );

  if (!executionDraft || !executionFormData) {
    return;
  }

  updateExecutionTimestamps(executionDraft, executionFormData);
  updateExecutionValueMeasures(executionDraft, executionFormData);
};

const updateExecutionTimestamps = (
  executionDraft: Execution,
  executionFormData: Execution,
) => {
  for (const field of executionTimestampFields) {
    executionDraft[field] = executionFormData?.[field]
      ? formatAsUTCDate(executionFormData[field], datetime4server)
      : undefined;
  }
};

const updateExecutionValueMeasures = (
  executionDraft: Execution,
  executionFormData: Execution,
) => {
  const executionFields = [
    { name: 'co2Emission', hasMeasure: true },
    { name: 'co2EmissionPlanned', hasMeasure: true },
    { name: 'distance', hasMeasure: true },
    { name: 'distancePlanned', hasMeasure: true },
    { name: 'waitingTime', hasMeasure: false },
  ];

  for (const { name, hasMeasure } of executionFields) {
    updateNumericField(
      executionFormData?.[name],
      hasMeasure,
      executionDraft,
      name,
    );
  }
};
